import { useCallback, useEffect, useState } from 'react';

import { Stimulsoft } from 'app/libs/stimulsoft/stimulsoft.reports';

type UseReportDesignerControllerParams = {
  onSaveReport?: (event: Stimulsoft.Designer.SaveReportArgs) => void;
  onSaveAsReport?: (event: Stimulsoft.Designer.SaveReportArgs) => void;
};

export const useReportDesignerController = (
  params: UseReportDesignerControllerParams = {},
) => {
  const [reportDesigner, setReportDesigner] = useState(() => {
    window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile(
      '/reports/ss-ru.xml',
      true,
    );

    window.Stimulsoft.Base.StiLicense.loadFromFile('/reports/license.key');
    window.Stimulsoft.StiOptions.WebServer.encryptData = false;
    window.Stimulsoft.StiOptions.WebServer.url = '/ws/api/report_db_handler';

    const reportDesigner = new window.Stimulsoft.Designer.StiDesigner(
      undefined,
      'ReportDesigner',
      false,
    );

    reportDesigner.options.height = '100%';

    // create report
    const report = new window.Stimulsoft.Report.StiReport();

    report.reportFile = '';
    report.reportName = 'Новый отчёт';

    // attach report
    reportDesigner.report = report;

    // subscribe to events
    if (reportDesigner && params?.onSaveReport) {
      reportDesigner.onSaveReport = params.onSaveReport;
    }

    if (reportDesigner && params?.onSaveAsReport) {
      reportDesigner.onSaveAsReport = params.onSaveAsReport;
    }

    return reportDesigner;
  });

  useEffect(() => {
    if (reportDesigner && params?.onSaveReport) {
      reportDesigner.onSaveReport = params.onSaveReport;
    }

    if (reportDesigner && params?.onSaveAsReport) {
      reportDesigner.onSaveAsReport = params.onSaveAsReport;
    }
  }, [params?.onSaveReport, params?.onSaveAsReport, reportDesigner]);

  useEffect(() => {
    return () => {
      if (reportDesigner?.jsObject) {
        reportDesigner.dispose();
      } else {
        // @ts-expect-error ...
        setReportDesigner(null);
      }
    };
  }, [reportDesigner]);

  const attachReportFile = useCallback(
    ({ file, name }: { file: Blob; name?: string }) => {
      const url = URL.createObjectURL(file);

      // create new report
      const report = new window.Stimulsoft.Report.StiReport();

      // load report template to report
      report.loadFile(url);

      // rename report file
      report.reportFile = name || '';
      report.reportName = name || '';

      if (!reportDesigner) return;

      reportDesigner.report = report;
    },
    [reportDesigner],
  );

  return { controller: reportDesigner, attachReportFile };
};
